/** Sentinel that matches no real status. Empty intersection must not fall back to "all". */
const NO_MATCH = -9999;

function asList<T>(value?: T | T[] | null): T[] | undefined {
  if (value == null || (value as unknown) === '') return undefined;
  const list = Array.isArray(value) ? value : [value];
  return list.length ? list : undefined;
}

/** Tab filter and column filter on the same field. Either side alone is kept; both narrow. */
export function intersectFilters<T>(tab?: T | T[] | null, column?: T | T[] | null): T[] | undefined {
  const left = asList(tab);
  const right = asList(column);
  if (!left && !right) return undefined;
  if (left && right) {
    const allowed = new Set(right);
    const hit = left.filter((value) => allowed.has(value));
    return hit.length ? hit : [NO_MATCH as T];
  }
  return left ?? right;
}
